<template>
  <DragDialog
    title="转换配置"
    :width="500"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="vector-lod-box">
      <div class="title-box">
        <span class="dialog-label">矢量切片精度</span>
        <el-tooltip
        :effect="$theme.tooltipKey()"
          placement="top-start"
          popper-class="common-panel-tooltip-box"
        >
          <div slot="content">
            矢量切片精度对应于LOD等级，值越大，矢量查看精度越高，所需转换时间越长
          </div>
          <div class="icon-box">
            <icon-svg icon-class="ic-fail-upload" class="icon" />
          </div>
        </el-tooltip>
      </div>
      <div class="common-slider-box">
        <el-slider
        class="slider-primary"
          input-size="small"
          v-model="currVectorLod"
          :mim="0"
          :max="22"
          :step="1"
          @input="handleSliderInput"
        />
      </div>
      <div v-if="isTipVisible" class="tip-box">
        <div class="icon-box">
          <i class="el-icon-warning"></i>
        </div>
        <div>切片精度设置过大，会导致文件转换时间较长</div>
      </div>
      <div class="common-button-box">
        <el-button size="small" class="normal-ang-btn gr8 hollowOut-btn" @click="cancel">取消</el-button>
        <el-button type="primary" size="small" class="primary-btn primary-ang-btn sumbit-btn" @click="submit">转换</el-button>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

export default {
  data() {
    return { currVectorLod: 10, isTipVisible: false };
  },
  props: {
    visible: Boolean,
    initVectorLodInfo: Object,
    submitConvert: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    initVectorLodInfo: function (newValue) {
      if (Object.keys(newValue).length) {
        let currentLod = newValue.currentLod;
        this.currVectorLod = Number(currentLod);
      }
    },
  },
  methods: {
    handleSliderInput(currVectorLod) {
      let vectorLodInfo = this.initVectorLodInfo;
      let recommendLod = vectorLodInfo.recommendLod;
      recommendLod = Number(recommendLod);
      if (currVectorLod > recommendLod) {
        this.isTipVisible = true;
      } else {
        this.isTipVisible = false;
      }
    },
    submit() {
      let params = { lod: this.currVectorLod };
      this.submitConvert(params);
    },
    cancel() {
      this.currVectorLod = 10;
      this.isTipVisible = false;
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.vector-lod-box {
  color: var(--default-color);

  .title-box {
    display: flex;
    align-items: center;

    .icon {
      color: var(--vector-dialog-icon-color);
      margin-left: 5px;
    }
  }

  .common-slider-box {
    margin: 16px 0px;
    padding: 0px 28px;
    background: var(--slider-bgColor);
    border: 1px solid var(--slider-border-color);
    border-radius: 8px;
  }

  .tip-box {
    display: flex;
    margin: 10px 5px;
    align-items: center;
    color: #ec9d00;
    font-size: 12px;

    .icon-box {
      font-size: 16px;
      margin-right: 5px;
    }
  }

  .common-button-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>